import axios from "axios";
import $day from "dayjs"
const module = {
  namespaced: true,
  state: {
    data: {
      user_couple: '',
    },
  },
  mutations: {
    fetchData: (state, info) => {
      if(info.user_couple) {
        info.user_couple.map((item) => {
          item.editableFlag = true
          return item
        })
        state.data = info
      } else {
        state.data = []
      }

    },
    addData: (state, info) => {
      info.user_couple.editableFlag = true
      state.data.user_couple.push(info.user_couple)
    },
    updateData: (state, info) => {
      return state.data.user_couple = state.data.user_couple.map((item) => {
        if (item.id == info.id) {
          item = info
        }
        return item
      })
    },
    removeData: (state, info) => {
      return state.data.user_couple = state.data.user_couple.map((item) => {
        return item.id != info
      })
    },
  },
  actions: {
    async fetchData ({commit, rootState}) {
      const response = await axios.get('admin/users/data/'+rootState.user.currentUser)
      commit ('fetchData', response.data.user_data)
    },
    async updateData ({commit}, data) {
      data.birth_date = $day(data.birth_date).format('YYYY-MM-DD HH:mm:ss')
      data.relationship = 'Pareja'
      const response = await axios.put('admin/user/data/couple/'+data.id, data)
      commit ('updateData', response.data)
    },
    async addData ({commit, rootState}, data) {
      data.birth_date = $day(data.birth_date).format('YYYY-MM-DD HH:mm:ss')
      data.relationship = 'Pareja'
      data.user_id = rootState.user.currentUser
      const response = await axios.post('admin/user/data/couple', data)
      commit ('addData', response.data)
    },
    async removeData ({commit}, id) {
      await axios.delete('admin/user/data/couple/'+id).then(() => {
        commit ('removeData', id)
      })
    },
  }
}
export default module
